module.exports = __webpack_public_path__ + "static/media/Tech_firstPage_ko.9b351839.png";